import { Box, Flex, Panel, Text } from 'components'
import { useWorkspace } from 'components/providers'
import { generatePath, useNavigate } from 'react-router'
import { useBreakpoint } from 'utils'
import RegistrationConsentTileViewer from '../components/consentContent/RegistrationConsentTileViewer'
import { useRegistrationConsents } from '../utils/registrationConsentUtils'
import { RoutePath } from '../utils/routing'

export default function RegistrationConsentsPage() {
  const { workspace } = useWorkspace()
  const navigate = useNavigate()
  const { registrationConsents } = useRegistrationConsents()
  const isMobile = useBreakpoint() < 1
  const breakpoint = useBreakpoint()

  return (
    <Flex
      direction="column"
      gap={4}
      flex="auto"
      p={isMobile ? 4 : 0}
      pb={3}
      overflowY="auto"
      overflowX="hidden"
    >
      <Text textStyle="h3" pt={2}>
        Registration Consents
      </Text>
      <Flex direction="column" gap={2} overflowY="auto" pr={5}>
        {breakpoint > 3 && (
          <Flex width="100%" pl={2} gap={3}>
            <Text {...headingTextProps} flex={1}>
              Title
            </Text>
            <Flex align="center" gap={3} flexShrink={0}>
              <Text {...headingTextProps} width="200px">
                Created By
              </Text>
              <Text {...headingTextProps} width="120px">
                Last Updated
              </Text>
              <Box width="50px" flexShrink={0} />
            </Flex>
          </Flex>
        )}
        {registrationConsents?.map(consent => (
          <Panel key={consent.id} flex={1} p={4} gap={6} width="auto">
            <RegistrationConsentTileViewer
              consent={consent}
              onEdit={() =>
                navigate(
                  generatePath(RoutePath.RegistrationConsentInfo, {
                    workspaceId: workspace!.id,
                    id: consent.id,
                  })
                )
              }
            />
          </Panel>
        ))}
      </Flex>
    </Flex>
  )
}

const headingTextProps = {
  textStyle: 'bodySmall' as const,
}
